import { useContext, useEffect, useRef, useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import { CircleAlert } from "lucide-react";
import { Check } from "lucide-react";

import { AssitanceAdjustViewContext } from "../../components/AssistanceAdjustList/AssistanceAdjustList";
import { PatientsListContext } from "../../components/PatientsList/PatientsList";
import "./ConfirmationModal.scss";

export default function ConfirmationModal(props: { title: string }) {
	const [actualNurse, setActualNurse] = useState<any>({});
	const {
		selectedNurses,
		nurses,
		selectedNurse,
		availableAreas,
		selectedArea,
		availableNurses,
		replacementNurse,
		clearFieldsNClose,
	} = useContext(AssitanceAdjustViewContext);

	const { selectedPatient, setOpenConfirmationModal } = useContext(PatientsListContext);
	const closeButtonRef = useRef<any>(null);

	useEffect(() => {
		setActualNurse(nurses.find((e: any) => e.id === selectedNurses[0]));
	}, [selectedNurses]);

	useEffect(() => {
		if (closeButtonRef.current) {
			closeButtonRef.current.focus();
		}
	}, []);

	const ModalTitle = () => {
		let displayTitle;

		switch (props.title) {
			case "Agregar Profesional":
				displayTitle = "Profesional agregado.";
				break;
			case "Mover Profesional":
				displayTitle = "Movimiento completado.";
				break;
			case "Reemplazar Profesional":
				displayTitle = "Reemplazo completado.";
				break;
			case "Eliminar Profesional":
				displayTitle = "Profesional eliminado.";
				break;
			case "Alta de Paciente":
				displayTitle = "Paciente dado de alta.";
				break;
			case "Algo salió mal":
				displayTitle = "Algo salió mal.";
				break;
			case "Algo salió mal.":
				displayTitle = "Algo salió mal.";
				break;
			case "Paciente asignado":
				displayTitle = "Paciente asignado";
				break;
			case "Actualización exitosa":
				displayTitle = "Actualización exitosa.";
				break;
			case "Error":
				displayTitle = "Error.";
				break;
		}
		return (
			<Typography className="confirmation-modal-card-content-title">
				{displayTitle}
			</Typography>
		);
	};

	useEffect(() => {
		setActualNurse(nurses.find((e: any) => e.id === selectedNurses[0]));
	}, [selectedNurses]);

	const ModalDescription = () => {
		let addedNurseName, selectedAreaName, replacementNurseName;
		if (
			props.title !== "Alta de Paciente" &&
			props.title !== "Algo salió mal" &&
			props.title !== "Actualización exitosa" &&
			props.title !== "Paciente asignado"
		) {
			addedNurseName = availableNurses.find((nurse: any) => nurse.id === selectedNurse)?.name;

			selectedAreaName = availableAreas.find((area: any) => area.id === selectedArea)?.area;

			replacementNurseName = availableNurses.find(
				(nurse: any) => nurse.id === replacementNurse,
			)?.name;
		}

		let displayDescription = <Box></Box>;

		switch (props.title) {
			case "Agregar Profesional":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se ha agregado al profesional "<b>{addedNurseName}</b>" al turno.
					</Typography>
				);
				break;
			case "Mover Profesional":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se ha movido al profesional "<b>{actualNurse.nursename}</b>" a{" "}
						{selectedAreaName}.
					</Typography>
				);
				break;
			case "Reemplazar Profesional":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se ha reemplazado al profesional "<b>{actualNurse.nursename}</b>" por el
						profesional "<b>{replacementNurseName}</b>".
					</Typography>
				);

				break;
			case "Eliminar Profesional":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se ha eliminado exitosamente al profesional seleccionado.
					</Typography>
				);
				break;

			case "Alta de Paciente":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se ha dado de alta exitosamente al paciente "<b>{selectedPatient?.name}</b>
						".
					</Typography>
				);
				break;
			case "Algo salió mal":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Ocurrió un error inesperado, favor de contactar al administrador del
						sistema.
					</Typography>
				);
				break;
			case "Algo salió mal.":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Ocurrió un error inesperado, favor de contactar al administrador del
						sistema.
					</Typography>
				);
				break;
			case "Paciente asignado":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se ha asignado exitosamente al paciente "<b>{selectedPatient?.name}</b>
						".
					</Typography>
				);
				break;
			case "Actualización exitosa":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						Se han aplicado exitosamente los cambios al paciente "
						<b>{selectedPatient?.name}</b>
						".
					</Typography>
				);
				break;

			case "Error":
				displayDescription = (
					<Typography
						variant="body1"
						className="confirmation-modal-card-content-description"
					>
						No se añadió, ya existe el profesional en el área.
					</Typography>
				);
				break;
		}
		return <Box className="confirmation-modal-card-content-title">{displayDescription}</Box>;
	};

	const ModalAction = (e?: any) => {
		if (
			props.title !== "Alta de Paciente" &&
			props.title !== "Algo salió mal" &&
			props.title !== "Actualización exitosa" &&
			props.title !== "Paciente asignado"
		) {
			clearFieldsNClose();
			e.currentTarget.blur();
		} else {
			setOpenConfirmationModal(false);
		}
	};

	return (
		<Box className="confirmation-modal-card">
			<Box className="confirmation-modal-card-content">
				<Box className="confirmation-modal-card-content-icon-container">
					{props.title === "Algo salió mal" ||
					props.title === "Algo salió mal." ||
					props.title === "Error" ? (
						<CircleAlert className="confirmation-modal-card-content-icon-container-icon--error" />
					) : (
						<Check className="confirmation-modal-card-content-icon-container-icon" />
					)}
				</Box>
				<Box>
					<ModalTitle />
					<ModalDescription />
				</Box>
				<Button
					ref={closeButtonRef}
					className={
						props.title === "Algo salió mal" ||
						props.title === "Algo salió mal." ||
						props.title === "Error"
							? "confirmation-modal-card-content-button--error"
							: "confirmation-modal-card-content-button"
					}
					fullWidth
					disableRipple
					onClick={(e) => ModalAction(e)}
				>
					<Check style={{ marginRight: "12px" }}></Check>
					Cerrar
				</Button>
			</Box>
		</Box>
	);
}
